if (typeof SliderComponent !== 'undefined' && !customElements.get('product-slider-bimani')) {
  class ProductSliderBimani extends SliderComponent {
    constructor() {
      super()

      if (!this.slider) return

      this.isDragging = false
      this.dragMoved = false
      this.dragStartX = 0
      this.dragStartScrollLeft = 0

      this.onDragMove = this.onDragMove.bind(this)
      this.onDragEnd = this.onDragEnd.bind(this)

      // Plain mouse events (rather than Pointer Events + setPointerCapture) so
      // that click-through to product links keeps working reliably: some
      // browsers retarget or swallow the click after a captured pointer.
      this.slider.addEventListener('mousedown', this.onDragStart.bind(this))
      this.slider.addEventListener('click', this.onDragClick.bind(this), true)
      this.slider.addEventListener('dragstart', (event) => event.preventDefault())
    }

    onDragStart(event) {
      if (event.button !== 0) return

      this.isDragging = true
      this.dragMoved = false
      this.dragStartX = event.clientX
      this.dragStartScrollLeft = this.slider.scrollLeft

      this.slider.classList.add('is-dragging')

      document.addEventListener('mousemove', this.onDragMove)
      document.addEventListener('mouseup', this.onDragEnd)
    }

    onDragMove(event) {
      if (!this.isDragging) return

      // The mouse button can be released outside the document (browser chrome,
      // another window) without ever firing "mouseup" here. Self-heal on the
      // next move instead of leaving the drag stuck on.
      if (event.buttons === 0) {
        this.onDragEnd()
        return
      }

      const delta = event.clientX - this.dragStartX
      if (Math.abs(delta) > 3) this.dragMoved = true

      this.slider.scrollLeft = this.dragStartScrollLeft - delta
    }

    onDragEnd() {
      if (!this.isDragging) return

      this.isDragging = false
      this.slider.classList.remove('is-dragging')

      document.removeEventListener('mousemove', this.onDragMove)
      document.removeEventListener('mouseup', this.onDragEnd)
    }

    onDragClick(event) {
      if (!this.dragMoved) return

      event.preventDefault()
      event.stopPropagation()
      this.dragMoved = false
    }
  }

  customElements.define('product-slider-bimani', ProductSliderBimani)
}
